<template>
  <div class="ma-0 pa-0">
    <v-row>
      <v-col cols="3" class="px-1">
        <v-select
          v-model="disposition"
          :items="disposition_options"
          label="Notice Type"
          dense
          solo
          outlined
        ></v-select>
      </v-col>
      <v-col cols="3" class="px-1">
        <v-text-field
          v-model="keyword"
          outlined
          flat
          hide-details
          label="Keyword"
          prepend-inner-icon="mdi-filter"
          class="ma-0 pa-0 font-regular"
          style="max-height:40px;"
          dense
          solo
        ></v-text-field>
      </v-col>
      <v-col v-if="saved_searches.length" cols="4" class="px-1">
        <v-select
          v-model="selected_profile"
          :items="saved_searches"
          :loading="loadingSearches"
          item-text="name"
          label="Search Profile"
          outlined
          dense
          solo
          class="pb-0"
          return-object
        ></v-select>
      </v-col>
      <v-col cols="2" class="px-1">
        <span>
          <v-btn
            class="text-capitalize body-2 desktop-nav"
            color="#4EB888"
            small
            icon
            @click="run_filter()"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </span>
        <span>
          <v-btn
            class="text-capitalize body-2 mobile-nav"
            color="#4EB888"
            small
            icon
            @click="showHideMini(); run_filter()"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </span>
        <span>
          <v-btn
            class="caption text-capitalize"
            color="#2c9dd5"
            icon
            @click="reset_filters"
          >
            <v-icon>mdi-rotate-left</v-icon>
          </v-btn>
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import { bus } from "@/main.js";
import { getInstance } from "../auth/index.js";

export default {
  props: {
    source: String,
    mini: Boolean,
  },
  data() {
    return {
      saved_searches: [],
      search: "",
      selected_profile: {},
      isLoading: false,
      disposition: "",
      disposition_options: [
        "Contract Notice",
        "Request",
        "Grant",
        "Grant Opportunity",
      ],
      keyword: "",
    };
  },
  mounted() {
    this.getSavedSearches();
  },
  methods: {
    showHideMini() {
      bus.$emit("mini", true);
    },
    run_filter() {
      var qry = JSON.parse(JSON.stringify(this.$route.query));
      delete qry["user_id"];
      delete qry["keyword"];
      delete qry["disposition"];
      delete qry["search_id"];
      
      // //console.log("Before Update: ", qry);
      qry["keyword"] = this.keyword;
      qry["disposition"] = this.disposition;
      qry["search_id"] = this.selected_profile.id;
      // //console.log("After Update:", qry);

      /* const query = {
        path: "/inbox",
        query: {
          keyword: this.keyword,
          disposition: this.disposition,
          search_id: this.selected_profile.id,
        },
      }; */
      try{
        if (JSON.stringify(this.$route.query) !== JSON.stringify(qry)) {
          this.$router.replace({path: "/inbox", query: qry})
          .then(() => {
            bus.$emit("reloadInbox");
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              //console.error(err);
            }
          });
        }
        else {
          bus.$emit("reloadInbox");
        }
      }
      catch (error) {
        //console.error("Unexpected error in run_filter():", error);
      }
    },

    reset_filters() {
      this.disposition = "";
      this.keyword = "";
      this.selected_profile = {};
      this.$router.replace({ path: "/inbox" });
    },

    async getSavedSearches() {
      this.isLoading = true;
      try {
        const instance = getInstance();
        const accessToken = await instance.getTokenSilently();
        const response = await axios.get(process.env.VUE_APP_API_SEARCHES, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        this.saved_searches = response.data.saved_searches;
      } catch (error) {
        //console.error("Error fetching saved searches:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.wrap-text {
  word-wrap: normal !important;
}

.chip-label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.nav-list {
  background-color: "#303030";
  border-bottom: 2pt white;
}

.list-item {
  text-decoration: none !important;
  color: "#FFFFFF" !important;
}

.bottom-border {
  border-bottom: 2pt white;
}

.v-input__append-outer .v-icon:hover {
  color: rgb(78, 184, 136);
}
</style>
